var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between align-items-center py-2 px-3",attrs:{"id":"footer"}},[_c('span'),_c('a',{attrs:{"href":"https://tourobs.ch","target":"_blank"}},[_c('img',{attrs:{"src":require(`@/assets/logo/TourobsLogo.png`),"height":"40"}})]),_c('span',[_vm._v("© Tourobs "+_vm._s(_vm.currentYear))])])
}
var staticRenderFns = []

export { render, staticRenderFns }